module.exports = __webpack_public_path__ + "static/media/ces.8e5d43f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ces.mp3
// module id = 8nIc
// module chunks = 1